import { BaseUIRoutingModule } from './base-ui/base-ui-routing.module'
import { BaseUIModule } from './base-ui/base-ui.module'
import { BaseModule } from './basemodule/base.module'

export const BaseFrameworkSubModules = [BaseUIModule,
    BaseUIRoutingModule,
    BaseModule
];